import Patrol from "../fragments/patrol";

export default `
mutation UpdatePatrol($input: UpdatePatrolInput!) {
  updatePatrol(input: $input) ${Patrol}
}
`;
